import styled from "styled-components";
import { Space } from "antd";
import { BackArrow } from '@assets';
import lightTheme from '@styles/theme';
import { AuthBg } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }

  .ant-btn-primary {
    margin-top: 32px;
    width: 100%;
    height: 52px;
    border-radius: 27px !important;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin: 259px auto 24px;

  @media (max-height: 700px) {
    margin-top: 200px !important;
  }
`

export const Title = styled.div`
  margin-bottom: 12px;
  text-align: center;
  text-transform: capitalize;
  color: #FFF;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const SubTitle = styled.div`
  margin: 0 18px 24px;
  color: var(--white, #FFF);
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledInput = styled.input`
  width: 53px !important;
  height: 60px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border:  ${(props) => (props.status === "error" ? "1px solid red" : "none")} !important;
  font-size: 17px !important;
  padding: 0;
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 45px !important;
    height: 50px !important;
  }
  @media screen and (max-width: 320px) {
    width: 40px !important;
    height: 40px !important;
  }
`;

export const BottomBox = styled(Space)`
  width: 100%;
  margin: 16px 0;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }
`;

export const BottomText = styled.div`
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
`;

export const TimeText = styled.div`
  color: #FFF;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 15px;
  height: 11px;
`;
